(function(context) {
    var
        HTML_DATA_ATTRIBUTE_SELECTOR = '[data-display-generic-popup=true]';

    new (Marionette.ItemView.extend({
        template: '#genericVitalityPopup_Tmpl',
        ui: {
            proceedTrigger: '#genericPopupButtonLink'
        },
        events: {
            'click @ui.proceedTrigger': 'onProceedTriggerClick',
            'hidden.bs.modal': 'onPopUpHidden'
        },
        initialize: function() {
            this.model = new (Backbone.Model.extend({
                defaults: {
                    contentReferences: null
                },
            }));
            this.render();
            this.listenTo(this.model, 'change', this.render);
            this.options.$body.on(
                'click',
                HTML_DATA_ATTRIBUTE_SELECTOR,
                function(e) {
                    var
                        $el = $(e.currentTarget),
                        isLink = $el.is('[href]'),
                        url = isLink && $el.attr('href'),
                        isViaIndividualAttributeDefinition = isLink && $el.is(HTML_DATA_ATTRIBUTE_SELECTOR);

                    if (this.ui.proceedTrigger.is($el)) {
                        return;
                    }

                    if (isLink) {
                        e.preventDefault();
                        var
                            contentReferencesSelector = $el.data('content-references'),
                            $contentReferences = $(contentReferencesSelector),
                            headerContent = '',
                            mainContent = '';

                        if ($contentReferences.length) {
                            var
                                contentReferencesTemplate = _.template($(contentReferencesSelector).html()),
                                contentDynamicDataReferences = $el.data('content-dynamic-data-references'),
                                templateHTML = contentReferencesTemplate(contentDynamicDataReferences && contentDynamicDataReferences.data),
                                $contentReferencesScope = $('<div />').html(templateHTML),
                                $headerContent = $contentReferencesScope.find('[data-header-content]'),
                                $mainContent = $contentReferencesScope.find('[data-main-content]');

                            if ($headerContent.length) {
                                headerContent = $headerContent.html();
                            }
                            if ($mainContent.length) {
                                mainContent = $mainContent.html();
                            }
                        }

                        var modelProps = _.extend(
                            {
                                headerContent: headerContent,
                                mainContent: mainContent
                            }
                        );

                        this.model.set(modelProps);
                        this.display(true);

                    }
                }.bind(this)
            );
        },
        onProceedTriggerClick: function () {
            this.display(false);
        },
        onPopUpHidden: function () {
            this.display(false);
            $('.modal:visible').length
                ? this.options.$body.addClass('modal-open')
                : $('.modal-backdrop').remove();
        },
        display: function (bool) {
            this.options.$body[((!! bool) ? 'add' : 'remove') + 'Class']('activeGenericPopup');
            this.$el.modal(!! bool ? 'show' : 'hide');
        },
        onRender: function(){
            var $el = this.$el = this.$el.children();
            $el.unwrap();
            this.setElement($el);
            ! this.options.$body.has($el).length && $el.appendTo(this.options.$body);
        }
    }))({$body: $(document.body)});
})(this);
